module.exports = __webpack_public_path__ + "img/monitor2.d09724c8.jpg";